import script from "./FieldRepeatable.vue?vue&type=script&lang=ts&setup=true"
export * from "./FieldRepeatable.vue?vue&type=script&lang=ts&setup=true"

import "./FieldRepeatable.vue?vue&type=style&index=0&id=74840df8&lang=css"

const __exports__ = script;

export default __exports__